/**
 * Große Dateien: Direkt-PUT nach S3, statt über /add zu gehen (client.md §10).
 * Vorbild: backendUpload(token, prefix, filename, folder, data).
 *
 * `prefix` ist der Umgebungs-Präfix des `botpilotfiles`-Buckets (util.s3prefix,
 * awschat/libs/s3api.py:138-140) — ein opaker, serverseitiger Konfigurationswert, der über
 * keinen botagent-Endpunkt zurückgegeben wird. Der Client kennt ihn daher nur, wenn er in
 * den Einstellungen hinterlegt ist (state/settings.ts, s3Prefix) — genau wie apiUrl.
 */

/** Knapp unter der 4-MB-Grenze von API-Gateway/`/add` (client.md §10). */
export const LARGE_FILE_THRESHOLD = 4 * 1024 * 1024 - 64 * 1024;

export function s3UploadUrl(prefix: string, folder: string, filename: string): string {
  return `https://${prefix}botpilotfiles.s3.amazonaws.com/input/${encodeURIComponent(folder)}/${encodeURIComponent(filename)}`;
}

export async function uploadLargeFile(prefix: string, folder: string, file: File): Promise<void> {
  const url = s3UploadUrl(prefix, folder, file.name);
  let res: Response;
  try {
    res = await fetch(url, {
      method: "PUT",
      headers: { "Content-Type": file.type || "application/octet-stream" },
      body: file,
    });
  } catch {
    throw new Error(`S3-Upload fehlgeschlagen (Netzwerkfehler): ${file.name}`);
  }
  if (!res.ok) throw new Error(`S3-Upload fehlgeschlagen (${res.status}): ${file.name}`);
}
